import { Filters, usePaginationFilter } from 'shared/lib/pagination';
import { TagCard } from 'shared/ui/cards/tagCard';
import { PaginationHook, TNameMapValue } from 'shared/lib/pagination';
import { FC } from 'react';

interface FilterTagsProps {
	names: Map<string, TNameMapValue>;
}

export const FilterTags: FC<FilterTagsProps> = ({ names }) => {
	const filters = usePaginationFilter()?.displayFilters as Filters;
	const { resetFilters, processFilters } =
		usePaginationFilter() as PaginationHook;

	const resetFilter = (filterIds: any[]) => () => {
		filterIds.forEach(filterId => {
			delete filters[filterId as keyof Filters];
		});

		resetFilters({ newFilters: filters, withRequest: true });
	};

	return processFilters(filters, names).map(filter => {
		return (
			<TagCard
				key={filter.name}
				name={filter.name}
				outputCloseButtonVariant={'white'}
				variant={'main'}
				onClick={resetFilter(filter.id)}
				padding="4px"
				typographyProps={{
					mode: 'small',
				}}
			/>
		);
	});
};
